/**
 * Close the gap left by a deleted row: every numeric row index after the
 * removed one moves down by one. Named entries ("uuid", "tuple", ...) are left
 * alone.
 *
 * Row indices arrive as strings (they are the point's metadata object keys) or
 * as numbers (rows added in this dialog session), so compare them as numbers.
 * A string comparison makes "2".."9" sort after "10": deleting row "10" then
 * shifts them too, two rows end up on "1", and the export keeps only one of
 * them - the hidden Study arm vanished this way on Knop, 2023. (DCTL-2716)
 *
 * @param {Array<{index: string|number}>} metadata - dialog rows, mutated in place
 * @param {string|number} removedIndex - index of the row that was deleted
 */
export function reindexAfterRowDelete(metadata, removedIndex) {
	if (isNaN(removedIndex)) return;
	const removed = Number(removedIndex);
	metadata.forEach((metadatum) => {
		if (!isNaN(metadatum.index) && Number(metadatum.index) > removed) {
			metadatum.index = String(metadatum.index - 1);
		}
	});
}
